import { Config } from './index';

const config: Config = {
  calculationApiUrl: 'https://api.b2tech.com/api/v1/calculate',
  debug: false,
  version: '0.0.1',
  environment: 'production'
};

export default config;